export default "__VITE_PUBLIC_ASSET__662bbfeb__"